import { Link } from "react-router-dom";
import { useEffect, useRef } from "react";
import { BACKEND_URL } from "../Config";
import { trybeCheckout } from "../MugEditorFeature/utils/trybeTracking";

export default function PaymentSuccess() {
    const trackedRef = useRef(false);

    useEffect(() => {
        if (trackedRef.current) return;
        trackedRef.current = true;

        const sessionId = new URLSearchParams(window.location.search).get("session_id");
        if (!sessionId) return;

        fetch(`${BACKEND_URL}/checkout_session_status?session_id=${encodeURIComponent(sessionId)}`)
            .then((res) => (res.ok ? res.json() : null))
            .then((data) => {
                if (!data) return;
                trybeCheckout({
                    orderId: data.orderId,
                    value: data.value,
                    currency: data.currency,
                    email: data.email || undefined,
                });
            })
            .catch((err) => console.error("Failed to fetch checkout session status:", err));
    }, []);

    return (
        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "#7a9a9a",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
        }}>
            <header style={{
                height: "10%",
                width: "100%",
                backgroundColor: "#3d5a5a",
                display: "flex",
                alignItems: "center",
                paddingLeft: "5%",
                borderBottom: "1px solid #2d4a4a"
            }}>
                <Link to="/" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
                    <h1 style={{ color: "#a8d8d8", fontFamily: "'Quicksand', sans-serif", margin: 0 }}>Mem</h1>
                    <h1 style={{ color: "#d4e8e8", fontFamily: "'Quicksand', sans-serif", margin: 0 }}>Case</h1>
                </Link>
            </header>

            <div style={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px"
            }}>
                <div style={{
                    maxWidth: "500px",
                    width: "100%",
                    backgroundColor: "#4a6a6a",
                    borderRadius: "20px",
                    padding: "40px",
                    boxSizing: "border-box",
                    border: "1px solid #3d5a5a",
                    textAlign: "center"
                }}>
                    <div style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                        backgroundColor: "#6b9e9e",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 30px",
                        boxShadow: "0 0 20px rgba(107, 158, 158, 0.4)"
                    }}>
                        <div style={{
                            fontSize: "48px",
                            color: "#f4f8f8"
                        }}>✓</div>
                    </div>

                    <h1 style={{
                        fontSize: "32px",
                        color: "#d4e8e8",
                        marginBottom: "20px",
                        fontFamily: "'Quicksand', sans-serif"
                    }}>
                        Thank You!
                    </h1>

                    <p style={{
                        fontSize: "18px",
                        color: "#a8d8d8",
                        marginBottom: "30px",
                        lineHeight: "1.6"
                    }}>
                        Your order has been received successfully.
                    </p>

                    <p style={{
                        fontSize: "16px",
                        color: "#8bb8b8",
                        marginBottom: "40px",
                        lineHeight: "1.6"
                    }}>
                        You should be receiving a confirmation email shortly with your order details.
                    </p>

                    <Link to="/" style={{ textDecoration: "none" }}>
                        <button style={{
                            width: "100%",
                            padding: "15px",
                            fontSize: "16px",
                            fontWeight: "600",
                            borderRadius: "10px",
                            border: "2px solid #3d5a5a",
                            backgroundColor: "#6b9e9e",
                            color: "#f4f8f8",
                            cursor: "pointer",
                            boxShadow: "0 0 10px 2px #6b9e9e",
                            fontFamily: "'Quicksand', sans-serif"
                        }}>
                            Return Home
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
}
